<template>
	<div class="autocomplete-control" v-click-outside="closeResults">
		<v-text-field :model-value="props.search" @update:model-value="$emit('update:search', $event)" @focus="showResults = true" :label="props.label" :density="props.density" :variant="props.variant" prepend-inner-icon="search" clearable hide-details autocomplete="off" class="autocomplete-control__field" />

		<v-card v-if="showResults && props.items.length" variant="outlined" class="autocomplete-control__results">
			<v-list :density="props.density">
				<v-list-item v-for="item in props.items" :key="item[props.itemValue]" :title="resolveTitle(item)" :subtitle="resolveSubtitle(item)" @click="onSelect(item)">
					<template #append>
						<slot name="append" :item="item"><v-icon>add</v-icon></slot>
					</template>
				</v-list-item>
			</v-list>
		</v-card>
		<p v-else-if="showResults" class="autocomplete-control__no-data text-caption text-disabled">{{ props.noDataText ?? t('NoData') }}</p>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useTranslator } from '@/composables/useTranslator';

const t = useTranslator();
const showResults = ref(false);

function closeResults() {
	showResults.value = false;
}

const props = defineProps({
	label: { type: String, default: '' },
	items: { type: Array, default: () => [] },
	search: { type: String, default: '' },
	titleKey: { type: [String, Function], default: 'label' },
	subtitleKey: { type: [String, Function], default: null },
	itemValue: { type: String, default: 'id' },
	density: { type: String, default: 'compact' },
	variant: { type: String, default: 'outlined' },
	clearOnSelect: { type: Boolean, default: false },
	noDataText: { type: String, default: null },
});

const emit = defineEmits(['update:search', 'select']);

function resolveTitle(item) {
	return typeof props.titleKey === 'function' ? props.titleKey(item) : item[props.titleKey];
}

function resolveSubtitle(item) {
	if (!props.subtitleKey) return undefined;
	return typeof props.subtitleKey === 'function' ? props.subtitleKey(item) : item[props.subtitleKey];
}

function onSelect(item) {
	emit('select', item);
	if (props.clearOnSelect) {
		emit('update:search', '');
	}
	showResults.value = false;
}
</script>

<style scoped lang="scss">
.autocomplete-control {
	position: relative;

	&__field {
		width: 100%;
	}

	&__results {
		position: absolute;
		top: calc(100% + 4px);
		left: 0;
		right: 0;
		z-index: 10;
		max-height: 400px;
		overflow-y: auto;
	}

	&__no-data {
		margin: 4px 0 0;
		padding: 4px 12px;
	}
}
</style>
